export class Page {
    from: number;
    to: number;
}
